import React, { createContext, useCallback, useContext, useEffect, useState } from 'react';
import { createPortal } from 'react-dom';
import styled, { withTheme } from 'styled-components';
import { Absolute } from '../Absolute/Absolute';
import { Animate } from '../Animate/Animate';
import { Flex } from '../Flex/Flex';
import { ThemeProvider } from '../ThemeProvider/ThemeProvider';
import { Toast } from '../Toast/Toast';
const ClickthroughAbsolute = /*#__PURE__*/styled(Absolute).withConfig({
  displayName: "ToastProvider__ClickthroughAbsolute",
  componentId: "sc-5saebu-0"
})(["pointer-events:none;"]);
/* istanbul ignore next */
export const ToastContext = createContext({
  addToast: () => {},
  removeToast: () => {}
});
/**
 * @public
 */
export const useToast = () => {
  return useContext(ToastContext);
};
let id = 0;
function _ToastProvider({
  children,
  domRootId = 'root',
  enterAnimation = 'slideInLeft',
  exitAnimation = 'slideOutLeft',
  lifespan,
  maxToasts = 3,
  theme,
  bottom = 20,
  top
}) {
  const [toasts, setToasts] = useState([]);
  const addToast = useCallback(options => {
    setToasts(prevToasts => [...prevToasts, {
      ...options,
      id: id++
    }]);
  }, []);
  const removeToast = useCallback(id => {
    setToasts(prevToasts => prevToasts.map(toast => toast.id === id ? {
      ...toast,
      removed: true
    } : toast));
  }, []);
  useEffect(() => {
    toasts.forEach(toast => {
      if (toast.removed) {
        setTimeout(() => {
          setToasts(prevToasts => prevToasts.filter(t => t.id !== toast.id));
        }, 200);
      }
    });
  }, [toasts, setToasts]);
  const toastsToRender = toasts.slice(0, maxToasts);
  return React.createElement(ToastContext.Provider, {
    value: {
      addToast,
      removeToast
    }
  }, children, createPortal(React.createElement(ThemeProvider, {
    theme: theme
  }, React.createElement(ClickthroughAbsolute, {
    top: top ? top : undefined,
    bottom: top ? undefined : bottom,
    width: '100%'
  }, React.createElement(Flex, {
    justifyContent: 'center',
    width: '100%'
  }, React.createElement(Flex, {
    flexDirection: 'column-reverse',
    justifyContent: 'center',
    minWidth: '300px'
  }, toastsToRender.map(toast => {
    const enterAnim = toast.enterAnimation || enterAnimation;
    const exitAnim = toast.exitAnimation || exitAnimation;
    return React.createElement(Animate, {
      key: toast.id,
      variant: toast.removed ? exitAnim : enterAnim
    }, React.createElement(Toast, {
      lifespan: lifespan,
      onRemoveClick: removeToast,
      ...toast,
      mt: 3
    }));
  }))))), document.getElementById(domRootId)));
}
/**
 * @public
 */
export const ToastProvider = /*#__PURE__*/withTheme(_ToastProvider);